import { ThemeProvider as MuiThemeProvider, getTheme } from '@lingoda/ui';
import { IconsProvider } from '@lingoda/ui/icons';

export const ThemeProvider = (props: { children: React.ReactNode }) => {
    const theme = getTheme();

    return (
        <MuiThemeProvider theme={theme}>
            <IconsProvider>{props.children}</IconsProvider>
        </MuiThemeProvider>
    );
};
